import { Message } from "primereact/message";

import { useCaseRateCptConflicts } from "../hooks/useCaseRateCptConflicts";

interface ICaseRateConflictBannerProps {
  excludeRulesetId?: string;
}

export function CaseRateConflictBanner({
  excludeRulesetId,
}: ICaseRateConflictBannerProps) {
  const { conflictingComboCount, totalCombos, hasConflicts } =
    useCaseRateCptConflicts({ excludeRulesetId });

  if (!hasConflicts) return null;

  const comboWord = totalCombos === 1 ? "combination" : "combinations";
  const detail =
    totalCombos === 1
      ? "One or more of the CPT codes you've added already belong to another case rate ruleset for this provider and payer. Remove or change the conflicting code(s) before saving."
      : `${conflictingComboCount} of ${totalCombos} provider/payer ${comboWord} include CPT code(s) that already belong to another case rate ruleset for the same provider and payer. Remove or change the conflicting code(s) before saving.`;

  return (
    <div className="mb-4">
      <Message severity="warn" text={detail} className="w-full" />
    </div>
  );
}
